module.exports = __webpack_public_path__ + "static/img/聚光.daafab6f.png";